import React from 'react';
import { Box, Typography, Fade } from '@mui/material';
import { WifiOff } from 'lucide-react';
import { useOnlineStatus } from '../hooks/useOnlineStatus';

export const OfflineBanner: React.FC = () => {
  const isOnline = useOnlineStatus();
  
  if (isOnline) {
    return null;
  }
  
  return (
    <Fade in={!isOnline}>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bgcolor: 'warning.main',
          color: 'warning.contrastText',
          py: 1,
          px: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          zIndex: 9999,
        }}
      >
        <WifiOff size={18} />
        <Typography variant="body2" fontWeight={500}>
          Sin conexión a internet
        </Typography>
      </Box>
    </Fade>
  );
};
